var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWordpressLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_389_121)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.84375 19.9991C2.84375 26.7903 6.79044 32.6593 12.5134 35.4405L4.32919 13.0166C3.3772 15.1504 2.84375 17.5118 2.84375 19.9991Z",
    fill: "#21759B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5818 19.1336C31.5818 17.0132 30.8202 15.5447 30.1669 14.4017C29.2972 12.9885 28.482 11.7916 28.482 10.3783C28.482 8.80117 29.6782 7.33303 31.3631 7.33303C31.4391 7.33303 31.5113 7.3425 31.5854 7.34674C28.5329 4.55021 24.4661 2.84277 19.9993 2.84277C14.0054 2.84277 8.73189 5.91811 5.66406 10.5762C6.0666 10.5883 6.44596 10.5967 6.76818 10.5967C8.56278 10.5967 11.3407 10.379 11.3407 10.379C12.2656 10.3245 12.3746 11.6829 11.4507 11.7923C11.4507 11.7923 10.5213 11.9016 9.48702 11.9558L15.735 30.5401L19.4897 19.2792L16.8166 11.9552C15.8927 11.901 15.0174 11.7916 15.0174 11.7916C14.0928 11.7374 14.2012 10.3238 15.1258 10.3783C15.1258 10.3783 17.9592 10.5961 19.6451 10.5961C21.4394 10.5961 24.2176 10.3783 24.2176 10.3783C25.1432 10.3238 25.2519 11.6823 24.3277 11.7916C24.3277 11.7916 23.3962 11.901 22.3639 11.9552L28.5643 30.3987L30.2756 24.68C31.0173 22.3069 31.5818 20.6024 31.5818 19.1336Z",
    fill: "#21759B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3021 21.5L15.1543 36.4585C16.6913 36.9103 18.3168 37.1575 20.0011 37.1575C21.9991 37.1575 23.9151 36.8121 25.6986 36.1849C25.6526 36.1115 25.6108 36.0334 25.5765 35.9486L20.3021 21.5Z",
    fill: "#21759B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.0548 11.7676C35.1286 12.3141 35.1704 12.9008 35.1704 13.5318C35.1704 15.2729 34.8452 17.2301 33.8658 19.6773L28.625 34.8297C33.7258 31.8552 37.1566 26.3291 37.1566 19.9995C37.157 17.0166 36.395 14.2115 35.0548 11.7676Z",
    fill: "#21759B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0002 0C8.97236 0 0 8.9717 0 19.9995C0 31.0286 8.97236 40 20.0002 40C31.0276 40 40.0013 31.0286 40.0013 19.9995C40.001 8.9717 31.0276 0 20.0002 0ZM20.0002 39.0833C9.47806 39.0833 0.917052 30.5223 0.917052 19.9995C0.917052 9.4774 9.47773 0.917052 20.0002 0.917052C30.5219 0.917052 39.0823 9.4774 39.0823 19.9995C39.0823 30.5223 30.5219 39.0833 20.0002 39.0833Z",
    fill: "#21759B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_389_121"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 39.999,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWordpressLogo);
export default __webpack_public_path__ + "static/media/wordpress-logo.8f37b3cece61e289563801a299a3e897.svg";
export { ForwardRef as ReactComponent };